import React from 'react';
import {
  BottomNavigation,
  BottomNavigationAction,
  Box,
  Grid,
  Link,
  Typography,
} from '@mui/material';
import Data from '../Data/PersonalInfo.json';
import styled from '@emotion/styled';
import PersonIcon from '@mui/icons-material/Person';
import PlaceIcon from '@mui/icons-material/Place';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import GitHubIcon from '@mui/icons-material/GitHub';
import MailIcon from '@mui/icons-material/Mail';

//  Customised Typography
const StyledTypography = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontFamily: 'Neue Montreal Medium',
}));

// Customised Box
const StyledBox = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
}));

const AboutMe = () => {
  const { name, place, linkedIn, github, email } = Data.contactMe;
  return (
    <Grid container spacing={1} alignItems='center' sx={{ p: 3 }}>
      <Grid item xs={12} sm={12} md={4} lg={6}>
        {/* --- Name and Location ---- */}
        <StyledBox>
          <PersonIcon sx={{ marginRight: '0.5rem' }} />
          <StyledTypography variant='h6'>{name}</StyledTypography>
        </StyledBox>
        <StyledBox>
          <PlaceIcon sx={{ marginRight: '0.5rem' }} />
          <StyledTypography variant='h6'>{place}</StyledTypography>
        </StyledBox>
      </Grid>

      {/* ----- Contact Links -----  */}
      <Grid item xs={12} sm={12} md={8} lg={6}>
        <Box sx={{ my: 2 }}>
          <BottomNavigation showLabels>
            <BottomNavigationAction
              component={Link}
              href={linkedIn}
              target='_blank'
              rel='noopener noreferrer'
              icon={<LinkedInIcon />}
              label='LinkedIn'
            />
            <BottomNavigationAction
              component={Link}
              href={github}
              target='_blank'
              rel='noopener noreferrer'
              icon={<GitHubIcon />}
              label='Github'
            />
            <BottomNavigationAction
              component={Link}
              href={`mailto:${email}`}
              icon={<MailIcon />}
              label='Email'
            />
          </BottomNavigation>
        </Box>
      </Grid>
    </Grid>
  );
};

export default AboutMe;
